"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceConfiguration = void 0;
const typeorm_1 = require("typeorm");
const JournaledEntity_1 = require("../../JournaledEntity");
const PriceUnit_1 = require("./PriceUnit");
const ServiceClass_1 = require("../../service/entity/ServiceClass");
const Language_1 = require("../../language/entity/Language");
const ExpressPrice_1 = require("./ExpressPrice");
class PriceConfiguration extends JournaledEntity_1.JournaledEntity {
}
exports.PriceConfiguration = PriceConfiguration;
__decorate([
    (0, typeorm_1.ManyToOne)(() => PriceUnit_1.PriceUnit),
    __metadata("design:type", PriceUnit_1.PriceUnit)
], PriceConfiguration.prototype, "priceUnit", void 0);
__decorate([
    (0, typeorm_1.RelationId)((sp) => sp.priceUnit),
    __metadata("design:type", String)
], PriceConfiguration.prototype, "priceUnitId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => ServiceClass_1.ServiceClass, { nullable: true }),
    __metadata("design:type", ServiceClass_1.ServiceClass)
], PriceConfiguration.prototype, "serviceClass", void 0);
__decorate([
    (0, typeorm_1.RelationId)((sp) => sp.serviceClass),
    __metadata("design:type", String)
], PriceConfiguration.prototype, "serviceClassId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Language_1.Language, { nullable: true }),
    __metadata("design:type", Language_1.Language)
], PriceConfiguration.prototype, "sourceLanguage", void 0);
__decorate([
    (0, typeorm_1.RelationId)((sp) => sp.sourceLanguage),
    __metadata("design:type", String)
], PriceConfiguration.prototype, "sourceLanguageId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Language_1.Language, { nullable: true }),
    __metadata("design:type", Language_1.Language)
], PriceConfiguration.prototype, "targetLanguage", void 0);
__decorate([
    (0, typeorm_1.RelationId)((sp) => sp.targetLanguage),
    __metadata("design:type", String)
], PriceConfiguration.prototype, "targetLanguageId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], PriceConfiguration.prototype, "customConstraint", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], PriceConfiguration.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)(() => ExpressPrice_1.ExpressPrice),
    __metadata("design:type", ExpressPrice_1.ExpressPrice)
], PriceConfiguration.prototype, "price", void 0);
